import { Link } from "react-router"

export default function MainLayout({ children }) {
  return (
    <div className="container is-fluid mt-3">
      <nav className="level">
        <div className="level-left">
          <div className="level-item">
            <Link to="/">
              <img src="/logo192.png" className="logo" alt="Logo" />
            </Link>
          </div>
          <div className="level-item">
            <Link to="/">
              <code style={{ fontSize: "1.5em" }}>tinsv</code>
            </Link>
          </div>
        </div>
      </nav>
      <section className="section px-0 pt-3">
        {children}
      </section>
    </div>
  )
}
